/** Open/close bridge for the CV dossier viewer.
 *
 *  The viewer is mounted once, globally (App.tsx), but is opened from several
 *  places that don't share a React tree — the Arsenal scene's "View CV" button
 *  and the SYSTEM.MAP nav overlay. A module-level store keeps that wiring flat
 *  instead of threading state through every parent.
 */
export const CV_FILE = '/files/Abdelrahman-Abdelnasser-CV.pdf'

let open = false
const subscribers = new Set<() => void>()

function emit() {
  subscribers.forEach((fn) => fn())
}

export const cvStore = {
  subscribe(fn: () => void) {
    subscribers.add(fn)
    return () => { subscribers.delete(fn) }
  },
  getSnapshot: () => open,
  /** Server render never has the viewer open. */
  getServerSnapshot: () => false,
  set(next: boolean) {
    if (open === next) return
    open = next
    emit()
  },
}

export const openCV = () => cvStore.set(true)
export const closeCV = () => cvStore.set(false)
